import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} products
 * @returns {Workbook}
 */
export const exportExcel = async (products) => {
  products.forEach((product, index) => {
    if (!product.cost || product.cost === 0) product.cost = "SIN COSTO";
    if (!product.discount || product.discount === 0)
      product.discount = "SIN DESCUENTO";
    product.order = index + 1;
    product.categoryName = product.category.name;
  });

  const json = excelHelper.jsonToJson(
    [products],
    [
      {
        name: "PRODUCTOS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
          {
            inValue: "categoryName",
            outValue: "CATEGORIA",
          },
          {
            inValue: "code",
            outValue: "CODIGO",
          },
          {
            inValue: "price",
            outValue: "PRECIO",
          },
          {
            inValue: "cost",
            outValue: "COSTO",
          },
          {
            inValue: "discount",
            outValue: "DESCUENTO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName();
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = () => {
  return (
    formatHelper.toDateYYMMDD(new Date().toUTCString()) +
    "_reporte-general-productos.xlsx"
  );
};



// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductList/excel.js